import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BackNavigationComponent } from "../back-navigation/back-navigation.component";

@Component({
  selector: 'app-profile-edit',
  standalone: true,
  imports: [TranslateModule, BackNavigationComponent],
  templateUrl: './profile-edit.component.html',
  styleUrl: './profile-edit.component.scss'
})
export class ProfileEditComponent {
  @Input() isCreatingNew: boolean = false;
  @Input() backButtonLabel!: string;
  @Input() previewButtonLabel!: string;
  @Input() publishButtonLabel!: string;
  @Input() isPublishDisabled: boolean = false;
  @Input() isPreviewDisabled: boolean = false;

  @Output() goBack = new EventEmitter<void>();
  @Output() previewProfile = new EventEmitter<void>();
  @Output() publishProfile = new EventEmitter<void>();
  @Output() deleteProfile = new EventEmitter<void>();


  onGoBack(): void {
    this.goBack.emit();
  }


  onPreviewProfile(): void {
    this.previewProfile.emit();
  }

  
  onPublishProfile(): void {
    this.publishProfile.emit();
  }

  onDeleteProfile(): void {
    this.deleteProfile.emit();
  }
}


